<script lang="ts" setup>
defineEmits<{ (e: 'reload'): void }>()
</script>

<template>
  <div class="terms-stale" role="alert" data-test="terms-stale">
    <v-icon icon="mdi-file-document-refresh-outline" size="20" class="terms-stale-icon" />
    <span class="terms-stale-text">{{ $t('cart.checkout.errors.termsVersionStale') }}</span>
    <button type="button" class="terms-stale-btn" data-test="terms-stale-reload" @click="$emit('reload')">
      {{ $t('cart.checkout.errors.termsReload') }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
.terms-stale {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 18px;
  margin-bottom: 16px;
  background: rgba(255, 152, 0, 0.1);
  border: 1px solid rgba(255, 152, 0, 0.3);
  border-radius: 12px;
  color: #ffb74d;
  font-size: 0.9rem;
}

.terms-stale-icon {
  flex-shrink: 0;
}

.terms-stale-text {
  flex: 1 1 240px;
}

.terms-stale-btn {
  padding: 8px 16px;
  background: rgba(255, 152, 0, 0.15);
  border: 1px solid rgba(255, 152, 0, 0.35);
  border-radius: 8px;
  color: #ffb74d;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: rgba(255, 152, 0, 0.25);
  }
}
</style>
